/* FRAME v13 certificate directory — no external libraries; enhancement over rendered Shopify data. */
(()=>{
  'use strict';
  const init=(root)=>{
    if(root.dataset.coaReady==='true') return;
    root.dataset.coaReady='true';
    const tbody=root.querySelector('[data-coa-rows]');
    if(!tbody) return;
    const records=[...tbody.querySelectorAll('[data-frame-coa-entry]')].map((row,index)=>({
      row,index,
      search:(row.dataset.search||'').toLocaleLowerCase(),
      category:row.dataset.category||'',
      categoryLabel:row.dataset.categoryLabel||'',
      year:row.dataset.year||'',
      date:/^\d{4}-\d{2}-\d{2}$/.test(row.dataset.date||'') ? Date.parse(row.dataset.date) || 0 : 0,
      title:row.dataset.title||''
    }));
    if(!records.length) return;
    const search=root.querySelector('[data-coa-search]');
    const category=root.querySelector('[data-coa-category]');
    const year=root.querySelector('[data-coa-year]');
    const sort=root.querySelector('[data-coa-sort]');
    const reset=root.querySelector('[data-coa-reset]');
    const status=root.querySelector('[data-coa-status]');
    const empty=root.querySelector('[data-coa-no-results]');
    const pagination=root.querySelector('[data-coa-pagination]');
    const previous=root.querySelector('[data-coa-prev]');
    const next=root.querySelector('[data-coa-next]');
    const pageCount=root.querySelector('[data-coa-page-count]');
    const limit=Math.min(24,Math.max(1,parseInt(root.dataset.pageSize,10)||12));
    let page=1;
    const collator=new Intl.Collator(undefined,{sensitivity:'base',numeric:true});
    const uniqueCategories=new Map();
    const uniqueYears=new Set();
    records.forEach(record=>{
      if(record.category && !uniqueCategories.has(record.category))uniqueCategories.set(record.category,record.categoryLabel||record.category);
      if(record.year)uniqueYears.add(record.year);
    });
    [...uniqueCategories.entries()].sort((a,b)=>collator.compare(a[1],b[1])).forEach(([value,label])=>category?.add(new Option(label,value)));
    [...uniqueYears].sort((a,b)=>b.localeCompare(a)).forEach(value=>year?.add(new Option(value,value)));
    const ordered=[...records];
    const sortRows=()=>{
      const method=sort?.value||'date-desc';
      ordered.sort((a,b)=>{
        if(method==='title-asc'||method==='title-desc'){
          const difference=collator.compare(a.title,b.title)*(method==='title-desc'?-1:1);
          return difference||a.index-b.index;
        }
        const aDate=Number.isFinite(a.date)?a.date:0;
        const bDate=Number.isFinite(b.date)?b.date:0;
        if(!aDate)return bDate?1:a.index-b.index;
        if(!bDate)return -1;
        return (method==='date-asc'?aDate-bDate:bDate-aDate)||a.index-b.index;
      });
      ordered.forEach(item=>tbody.appendChild(item.row));
    };
    const render=()=>{
      const query=(search?.value||'').trim().toLocaleLowerCase();
      const categoryValue=category?.value||'all';
      const yearValue=year?.value||'all';
      const matched=ordered.filter(item=>
        (!query||item.search.includes(query))&&
        (categoryValue==='all'||item.category===categoryValue)&&
        (yearValue==='all'||item.year===yearValue)
      );
      const pages=Math.max(1,Math.ceil(matched.length/limit));
      page=Math.min(Math.max(1,page),pages);
      const visible=new Set(matched.slice((page-1)*limit,page*limit).map(item=>item.row));
      ordered.forEach(({row})=>{row.hidden=!visible.has(row);});
      if(empty)empty.hidden=matched.length!==0;
      if(reset)reset.hidden=!query&&categoryValue==='all'&&yearValue==='all';
      const from=matched.length?(page-1)*limit+1:0;
      const to=Math.min(page*limit,matched.length);
      if(status)status.textContent=matched.length?`Showing ${from}–${to} of ${matched.length} documents`:'0 documents match';
      if(pagination)pagination.hidden=matched.length<=limit;
      if(pageCount)pageCount.textContent=`Page ${page} of ${pages}`;
      if(previous)previous.disabled=page<=1;
      if(next)next.disabled=page>=pages;
    };
    const refresh=()=>{page=1;render();};
    search?.addEventListener('input',refresh);
    category?.addEventListener('change',refresh);
    year?.addEventListener('change',refresh);
    sort?.addEventListener('change',()=>{sortRows();refresh();});
    reset?.addEventListener('click',()=>{if(search)search.value='';if(category)category.value='all';if(year)year.value='all';refresh();search?.focus();});
    previous?.addEventListener('click',()=>{if(page>1){page--;render();}});
    next?.addEventListener('click',()=>{page++;render();});
    sortRows();render();
    const dialog=root.querySelector('[data-coa-dialog]');
    if(!dialog)return;
    const frame=dialog.querySelector('[data-coa-dialog-frame]');
    const image=dialog.querySelector('[data-coa-dialog-image]');
    const title=dialog.querySelector('[data-coa-dialog-title]');
    const open=dialog.querySelector('[data-coa-dialog-open]');
    let lastTrigger=null;
    tbody.addEventListener('click',event=>{
      const trigger=event.target.closest('[data-frame-coa-preview]');
      if(!trigger)return;
      let url;
      try{url=new URL(trigger.dataset.src||'',document.baseURI);}catch(_){return;}
      if(!['https:','http:'].includes(url.protocol))return;
      const kind=trigger.dataset.kind;
      if(!['pdf','image'].includes(kind))return;
      if(typeof dialog.showModal!=='function'){
        window.open(url.href,'_blank','noopener,noreferrer');return;
      }
      lastTrigger=trigger;
      const name=trigger.dataset.name||'Document preview';
      if(title)title.textContent=name;
      if(open)open.href=url.href;
      if(frame){frame.hidden=kind!=='pdf';frame.title=name;if(kind==='pdf')frame.src=url.href;}
      if(image){image.hidden=kind!=='image';image.alt=name;if(kind==='image')image.src=url.href;}
      dialog.showModal();
    });
    dialog.querySelector('[data-coa-close]')?.addEventListener('click',()=>dialog.close());
    dialog.addEventListener('click',event=>{if(event.target===dialog)dialog.close();});
    dialog.addEventListener('close',()=>{
      if(frame){frame.removeAttribute('src');frame.hidden=true;}
      if(image){image.removeAttribute('src');image.hidden=true;}
      lastTrigger?.focus({preventScroll:true});
    });
  };
  const initialize=(scope=document)=>{
    if(scope.matches?.('[data-frame-coa-directory]'))init(scope);
    scope.querySelectorAll?.('[data-frame-coa-directory]').forEach(init);
  };
  initialize();
  document.addEventListener('shopify:section:load',event=>initialize(event.target));
})();
